/*
 * @Author: qianyl
 * @Descripttion: 
 * @Date: 2025-07-08 13:32:47
 * @LastEditors: qianyl
 * @LastEditTime: 2025-07-09 13:51:35
 * @FilePath: \lesson-web-cms\src\store\authLogin.ts
 */
import * as selectUsr from "../api/selectUsr";
import * as ztSelectUser from "../api/ztSelectUser";
import { ref } from "vue"

export enum AuthLoginPaths {
  selectUser = "selectUser",
  ztSelectUser = "ztSelectUser",
}
export const authLoginStatusFn = () => {

  const path = ref(localStorage.getItem('authLoginPath'))
  
  const isDx = ref(false)
  const isZt = ref(false)

  if (path.value === AuthLoginPaths.selectUser) {
    isDx.value = true
  }
  if (path.value === AuthLoginPaths.ztSelectUser) {
    isZt.value = true
  }

  return {
    isDx,
    isZt,
    path,
  }
}
export const authLoginMiddleware = () => { 
  const { isDx, isZt, path } = authLoginStatusFn()
  let getMoreUserLogin = null
  let getLoginSelf = null
  if (isDx.value) {
    // 电信非登录页
    getMoreUserLogin = selectUsr.getMoreUserLogin
    getLoginSelf = selectUsr.getLoginSelf
  }

  if (isZt.value) {
    // 中台非登录页
    getMoreUserLogin = ztSelectUser.getMoreUserLogin
    getLoginSelf = ztSelectUser.getLoginSelf
  }

  return {
    getMoreUserLogin,
    getLoginSelf,
    isDx,
    isZt,
    path,
  }
}

export const removeAuthLoginPath = () => {
  localStorage.removeItem('authLoginPath')
}
